import merge from "lodash/merge";
import { type Styles } from "react-jss";

import { styles as fade, FADE_IN_ANIMATION_NAME, FADE_OUT_ANIMATION_NAME } from "./fadeAnimation.styles";
import {
  FADE_BOTTOM_IN_ANIMATION_NAME,
  FADE_BOTTOM_OUT_ANIMATION_NAME,
  styles as fadeFromBottom,
} from "./fadeMovedFromBottomAnimation.styles";
import {
  FADE_CENTER_IN_ANIMATION_NAME,
  FADE_CENTER_OUT_ANIMATION_NAME,
  styles as fadeFromCenter,
} from "./fadeMovedFromCenterAnimation.styles";
import {
  FADE_END_IN_ANIMATION_NAME,
  FADE_END_OUT_ANIMATION_NAME,
  styles as fadeFromEnd,
} from "./fadeMovedFromEndAnimation.styles";
import {
  MOVE_SIDE_IN_ANIMATION_NAME,
  MOVE_SIDE_OUT_ANIMATION_NAME,
  styles as moveFromSide,
} from "./moveFromSideAnimation.styles";
import { styles as noAnimation } from "./noneAnimation.styles";

// using merge and not safe merge because we want the key to contain special characters - "[], ()"
export const animations: Styles<"transitionable"> = merge(
  fade,
  fadeFromBottom,
  fadeFromCenter,
  fadeFromEnd,
  moveFromSide,
  noAnimation,
);

export const ANIMATION_NAMES = [
  FADE_BOTTOM_IN_ANIMATION_NAME,
  FADE_BOTTOM_OUT_ANIMATION_NAME,
  FADE_CENTER_IN_ANIMATION_NAME,
  FADE_CENTER_OUT_ANIMATION_NAME,
  FADE_END_IN_ANIMATION_NAME,
  FADE_END_OUT_ANIMATION_NAME,
  FADE_IN_ANIMATION_NAME,
  FADE_OUT_ANIMATION_NAME,
  MOVE_SIDE_IN_ANIMATION_NAME,
  MOVE_SIDE_OUT_ANIMATION_NAME,
];
